import { render, staticRenderFns } from "./DefiTokenPickerWindow.vue?vue&type=template&id=0f15c53c&"
import script from "./DefiTokenPickerWindow.vue?vue&type=script&lang=js&"
export * from "./DefiTokenPickerWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports